<!-- Begin Page Content -->
<div class="container-fluid">
  <!-- Page Heading -->

  <!-- DataTales Example -->
  <div class="mt-4">
    <!-- <div class="card-header bg-white py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Manage Warranty Condition
      </h1>
      <button
        type="button"
        class="btn"
        style="float: right"
        [routerLink]="['/component', 'warrantycondition', 'add-warranty']"
      >
        Add Warranty Condition
      </button>
    </div>-->
    
 <!-- Commented on 20th april 2026 for the breadcrumb changes -->
    <!-- <div [hidden]="showdivselect">
      <div class="col-6">
        <label for="name" class="form-label">Plant:</label>
        <select
          class="form-select border border-dark"
          name="plantid"
          (change)="getSelectedId($event)"
        >
        <option selected="true">Select Plant</option>
          <option *ngFor="let plant of plants" [value]="plant.Id">
            {{ plant.Name }}
          </option>
        </select>
      </div>
      <div class="col-6">
        <label for="train" class="form-label">Train:</label>
        <select
          class="form-select border border-dark"
          name="trainid"
          (change)="getSelectedTrainId($event)"
        >
          <option selected="true">Select Train</option>
          <option *ngFor="let train of allTrainList" [value]="train.Id">
            {{ train.Name }}
          </option>
        </select>
      </div>
    </div> -->
    
    <div class="col-6" id="dvUnit" *ngIf="showDvUnit">
      <div>
        <label for="tname" *ngIf="showName" style="font-size: xx-large;">Train Name: {{trainDetails.Name}}</label>
      </div>
      <label for="unit" class="form-label">Unit:</label>
      <select class="form-select border border-dark" name="unitid" disabled>
        <option
          *ngFor="let unit of units"
          [value]="unit.Id"
          [selected]="unit.Id === trainDetails.Units"
        >
          {{ unit.UnitName }}
        </option>
      </select>
    </div>
    <div style="min-height: 10px;"></div>

    <table
      datatable
      [dtOptions]="dtoptions"
      class="table table-bordered"
      width="100%"
      *ngIf="warrantyList.length > 0 && trainDetails"
    >
      <thead>
        <tr>
          <th>Warranty Name</th>
          <th>Warranty Name</th>
          <th>Maximun Value</th>
          <th>Minimum Temprature (&deg;C)</th>
          <th>Maximum Temprature (&deg;C)</th>
          <th>Minimum Feed TDS (ppm)</th>
          <th>Maximum Feed TDS (ppm)</th>
          <th *ngIf="trainDetails.Units == 0">Minimum Permeate Flow (m3/hr)</th>
          <th *ngIf="trainDetails.Units == 0">Maximum Permeate Flow (m3/hr)</th>
          <th *ngIf="trainDetails.Units == 1">Minimum Permeate Flow (gpm)</th>
          <th *ngIf="trainDetails.Units == 1">Maximum Permeate Flow (gpm)</th>
          <th>Graph</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let warrantyC of warrantyList">
          <td>
            <a
              class="text-black"
              (click)="navigate(warrantyC.Id)"
              >{{ warrantyC.Name }}</a
            >
          </td>
          <td>
            <a class="text-black">{{ warrantyC.Type }}</a>
          </td>
          <td>
            <a class="text-black">{{ warrantyC.MaxPermTds }}</a>
          </td>
          <td>
            <a class="text-black">{{ warrantyC.MinTemp }}</a>
          </td>
          <td>
            <a class="text-black">{{ warrantyC.MaxTemp }}</a>
          </td>
          <td>
            <a class="text-black">{{ warrantyC.MinFeedTds }}</a>
          </td>
          <td>
            <a class="text-black">{{ warrantyC.MaxFeedTds }}</a>
          </td>
          <td>
            <a class="text-black">{{ warrantyC.MinPermFlow }}</a>
          </td>
          <td>
            <a class="text-black">{{ warrantyC.MaxPermFlow }}</a>
          </td>
          <td>
            <button
        class="btn m-2"
        (click)="warrantiesgraph(warrantyC.TrainId,warrantyC.PlantId,plantDetails.Name,warrantyC.Id)"
        
      >
      Graph
      </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>